module.exports = __webpack_public_path__ + "static/media/logo199.7c8a1dd5.png";